import styled from "styled-components";

import { ProfileCouponsStyledProps as Props } from "./ProfileCoupons.types";
import CONSTANTS from "config/constants";

const { desktop, tablet, mobile } = CONSTANTS.BREAKPOINTS;

const ProfileCouponsStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  background-color: var(--palette-gray-s0-l97);
  padding-top: ${props =>
    !props.withBottomResponsiveButtons
      ? "var(--sizes-navbar-height-mobile-without-bottom-buttons)"
      : props.withBottomSearch
      ? "var(--sizes-navbar-height-mobile)"
      : "var(--sizes-navbar-height-mobile-without-search)"};
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr;
  grid-template-areas:
    "header header header"
    ".      main   ."
    "footer footer footer";

  @media (min-width: ${desktop}px) {
    padding-top: var(--sizes-navbar-height);
  }

  .ProfileCoupons {
    &__header {
      grid-area: header;

      .Clickable {
        @media (max-width: ${tablet}px) {
          display: none;
        }
      }
    }

    &__go-back {
      height: auto;
      margin-bottom: 2.4rem;

      .GoBack {
        &__title {
          font-weight: 600;
        }
      }

      @media screen and (min-width: ${desktop}px) {
        display: none;
      }
    }

    &__main {
      grid-area: main;
      margin-bottom: 3.2rem;
      padding-top: 8.8rem;

      @media screen and (min-width: ${desktop}px) {
        display: grid;
        grid-template-columns: 44rem 1fr;
        grid-template-rows: min-content max-content;
        grid-template-areas:
          "breadcrumb         breadcrumb"
          "profile-navigation coupons";
      }

      @media (max-width: ${tablet}px) {
        padding-top: 4rem;
      }
    }

    &__breadcrumb {
      display: none;

      @media screen and (min-width: ${desktop}px) {
        display: block;
        grid-area: breadcrumb;
        margin-bottom: 2.4rem;
      }
    }

    &__profile-navigation {
      display: none;

      @media screen and (min-width: ${desktop}px) {
        display: flex;
        grid-area: profile-navigation;
      }
    }

    &__container {
      grid-area: coupons;
      flex: 1;
      padding: 0 2rem;

      @media (min-width: ${desktop}px) {
        padding: 0 8rem;
      }

      @media (max-width: ${mobile}px) {
        padding: 0;
      }

      .Clickable {
        @media (max-width: ${tablet}px) {
          padding-left: 0;
          padding-top: 0;
        }
      }
    }

    &__coupons {
      display: flex;
      flex-direction: column;

      @media screen and (min-width: ${desktop}px) {
        padding: 3.2rem 1.6rem;
        border-radius: 0.4rem;
        padding-top: 0;
      }

      &__header {
        display: flex;
        flex-direction: column;
        border: 0.1rem solid var(--palette-gray-s0-l95);
        border-radius: 1.6rem;
        background-color: var(--palette-white);
        padding: 2.4rem;
        margin-bottom: 4.4rem;

        &__title {
          display: block;
          font-size: 2.4rem;
          line-height: 2.64rem;
          font-weight: 700;
        }

        &__subtitle {
          margin-top: 0.8rem;
          gap: 1.6rem;

          &--first {
            font-size: 1.6rem;
            line-height: 2rem;
            font-weight: 400;
            color: var(--palette-gray-s0-l25);
          }

          &--second {
            text-decoration: none;
            font-size: 1.6rem;
            line-height: 2rem;
            font-weight: 700;
            color: var(--palette-black-s0-l10);
          }

          @media screen and (min-width: ${tablet}px) {
            display: flex;
            align-items: center;
          }
        }
      }

      &__redeem {
        margin-top: 3.2rem;
        flex: 0.64;

        @media screen and (max-width: ${desktop}px) {
          flex: 1;
          padding: 1.6rem 0.8rem;
        }
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      border: 0.1rem solid var(--palette-gray-s0-l95);
      background-color: var(--palette-white);
      padding: 2.4rem 0.8rem;
      border-radius: 1.6rem;
    }

    &__section {
      font-size: 2rem;
      font-weight: 500;
      line-height: 3.2rem;
      margin-bottom: 2.4rem;
      padding-left: 2.4rem;

      @media (max-width: ${mobile}px) {
        padding-left: 0;
      }
    }

    &__apply-button {
      align-self: flex-end;
      margin-right: 2.4rem;

      @media (max-width: ${mobile}px) {
        margin-right: 0;
        align-self: stretch;
      }
    }

    &__tabs {
      padding-bottom: 2.4rem;
    }

    &__clickable {
      flex: 1;
      font-weight: 600;
    }

    &__item {
      &--active {
        border-bottom: 0.2rem solid var(--palette-primary);
      }
    }

    &__empty {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      align-items: center;
      border: 0.1rem solid var(--palette-gray-s0-l95);
      background-color: var(--palette-white);
      padding: 10rem 4rem;
      border-radius: 1.6rem;

      @media (max-width: ${mobile}px) {
        padding: 10rem 2.4rem;
      }

      &__message {
        font-size: 1.6rem;
        padding-top: 1.6rem;
        color: var(--palette-black-s0-l10);
        text-align: center;
      }
    }

    &__request {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 0.1rem solid var(--palette-gray-s0-l95);
      background-color: var(--palette-white);
      padding: 3.2rem 0.4rem;
      border-radius: 1.6rem;

      &__title {
        font-size: 2.4rem;
        line-height: 2.64rem;
        font-weight: 700;
        color: var(--palette-black-s0-l10);
        text-align: center;
      }

      &__description {
        font-size: 1.6rem;
        font-weight: 400;
        margin-top: 1.6rem;
        color: var(--palette-black-s0-l10);
        text-align: center;
        width: 80%;
        max-width: 43.2rem;
        line-height: 2rem;
      }

      &__button {
        margin-top: 1.6rem;
        font-weight: 700;
        height: 5.6rem;
        padding: 1.2rem 2.4rem;
      }
    }

    &__redeem-error {
      padding-top: 0.8rem;
      font-size: 1.2rem;
      color: var(--palette-red-s60-l60);
    }

    &__footer {
      grid-area: footer;
    }
  }
`;

export default ProfileCouponsStyled;
